import React, { useEffect, useState } from "react";
import NavBar from "./NavBar";
import { auth } from "../firebase";
import Heatmap from "./Heatmap";
import { getCurrentGoals } from "../util";
import EmailPreference from "./EmailPreferences";
import BugReport from "./BugReport";

const Profile = () => {
  const [user, setUser] = useState();
  const [goals, setGoals] = useState([]);

  useEffect(() => {
    getCurrentGoals(user, setGoals);
  }, [setGoals, user]);

  useEffect(() => {
    setInterval(() => {
      if (!user) setUser(auth.currentUser);
    }, 1000);
  }, []);

  return (
    <div className="relative">
      <NavBar />
      <div className="p-4">
        <p className="mb-4 text-4xl font-bold">{auth.currentUser?.displayName}</p>

        <p className="mt-4 text-xl font-bold">Email Preferences</p>
        <EmailPreference/>


        <p className="mt-4 text-xl font-bold">Progress 💪</p>


        {goals.map((goal) => (
          <div className="mt-1" key={goal.goal}>
            <Heatmap days={goal.days} />
          </div>
        ))}

      <div className="fixed right-2 bottom-4 z-10">
        <BugReport />
      </div>
      </div>
    </div>
  );
};

export default Profile;
